import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        toast.error('Invalid auth callback');
        navigate('/login', { replace: true });
        return;
      }

      try {
        const data = await handleGoogleCallback(sessionId);
        toast.success(`Welcome, ${data.user.name || data.user.username}!`);
        // Clear the hash and navigate to home
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user: data.user } });
      } catch (error) {
        console.error('Google auth failed:', error);
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <div className="ws-logo mb-4">
          <span className="ws-logo-war">WAR</span>
          <span className="ws-logo-syndicate">SYNDICATE</span>
        </div>
        <p className="text-[#666] mono text-sm">AUTHENTICATING...</p>
        <div className="mt-4 w-32 h-1 bg-[#222] mx-auto overflow-hidden">
          <div className="h-full bg-[#cc0000] animate-pulse" style={{ width: '60%' }} />
        </div>
      </div>
    </div>
  );
}
